// extracted by mini-css-extract-plugin
module.exports = {"header":"MobileHeader-hashed__header__VIdm4","header__back":"MobileHeader-hashed__header__back__2XC_V","header__title":"MobileHeader-hashed__header__title__15PcR"};